import Backbone from 'backbone'
import Header from './reports-wizard-header'
import Body from './reports-wizard-body'
import Footer from './reports-wizard-footer'
import _ from 'lodash'

var ReportWizardLayout = Backbone.View.extend({

	tagName: 'form',

	className: 'reports wizard',

	initialize: function(options) {
		this.header = new Header({ model: this.model })
		this.body = new Body({ model: this.model })
		this.footer = new Footer({ model: this.model })
	},

	render: function () {
		this.$el.empty().append(this.header.render().el, this.body.render().el,
			this.footer.render().el)

		return this
	},

	resize: function() {
		this.body.content.resize && this.body.content.resize()
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.header, this.body,
			this.footer], 'remove')
	}

})

export default ReportWizardLayout

ReportWizardLayout.__filename__ = 'reports/wizard/reports-wizard-layout.js'
